import React from "react";
import PropTypes from "prop-types";

import { RemoveButton, CloseIcon } from "./styles";

const RemovableTagComponent = ({
    text,
    isDisabled,
    tagHelperText,
    onClick,
    disableRemoveFromUI,
    updateVisible,
    isLink
}) => {
    const handleClick = e => {
        e.preventDefault();

        if (isDisabled) {
            return;
        }

        if (onClick) {
            onClick(text);
        }

        if (!isLink && !disableRemoveFromUI) {
            updateVisible(false);
        }
    };

    const helperText = isDisabled
        ? `Delete "${tagHelperText}" tag is disabled`
        : `Delete "${tagHelperText}" tag`;

    return (
        <RemoveButton
            aria-disabled={isDisabled}
            aria-label={helperText}
            title={helperText}
            onClick={e => handleClick(e)}
        >
            <CloseIcon />
        </RemoveButton>
    );
};

export default RemovableTagComponent;

// prop-types
RemovableTagComponent.propTypes = {
    prop: PropTypes.array
};
